import FinancialsTemplateFieldsFragment from "components/financials/modern/graphql/fragments/FinancialsTemplateFieldsFragment";
import gql from "graphql-tag";

export default gql`
  mutation SetAsDefaultFinancialsTemplate(
    $objectId: FinancialsTemplateID!
    $input: SetAsDefaultFinancialsTemplateInput!
  ) {
    setAsDefaultFinancialsTemplate(objectId: $objectId, input: $input) {
      ...FinancialsTemplateFields
    }
  }

  ${FinancialsTemplateFieldsFragment}
`;
